import createAction from './';

export const START_LOCKDOWN = createAction('START_LOCKDOWN');
export const FINISH_LOCKDOWN = createAction('FINISH_LOCKDOWN');


export const startLockdown = (unfreezeTimestamp) => (dispatch) => {
  const totalLockdownSeconds = Math.floor((Number(unfreezeTimestamp) - Date.now()) / 1000);

  return dispatch({
    type: START_LOCKDOWN,
    payload: {
      unfreezeTimestamp,
      totalLockdownSeconds,
    },
  });
};

export const finishLockdown = () => ({ type: FINISH_LOCKDOWN });
